import React, { useState, useEffect } from 'react';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Card, CardBody, Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';
import ReactRouterPropTypes from 'react-router-prop-types';
import columns from './components/Columns';
import {
  changeLoadingFalse,
  changeLoadingTrue,
} from '../../redux/actions/loadingActions';
import GraphQL from '../../GraphQL';
import { formatCpf } from '../../shared/format/format';
import {
  ACTION_NAME,
  DEFAULT_PAGE_SIZE,
  REPORT_PARAMETERS,
  REPORT_TYPES,
  SMART_BABY_USER,
} from '../../shared/utils/constants';
import {
  employeeListByFilter,
  employeeRemove,
  relationAccessProfileEmployeeListByEmployeeId,
  relationCommunicationChannelEmployeeListByEmployeeId,
  relationSubjectEmployeeListByEmployeeId,
} from '../../shared/queries/Employee';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import Modal from '../../shared/components/Modal';
import MatTable from '../../shared/components/material-table';
import { useSmartContext } from '../App/context/SmartProvider';
import EmployeeFilter from './components/EmployeeFilter';
import { schoolTermEmployeeRelationshipListByEmployeeIdQuery } from '../../shared/queries/SchoolTermEmployeeRelation';
import {
  generateReport,
  openReport,
  removeLabelAndValueObjectArray,
} from '../../shared/utils/smartutils';

const Employee = ({ t, dispatch, history }) => {
  const [data, setData] = useState([]);
  const [selectedDto, setSelectedDto] = useState({});
  const [modal, setModal] = useState(false);
  const { loggedUser } = useSmartContext();
  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const [accessProfile, setAccessProfile] = useState([]);
  const [schoolTerm, setSchoolTerm] = useState([]);

  const [subjects, setSubjects] = useState([]);
  const [communicationChannels, setCommunicationChannels] = useState([]);
  const [lastFilter, setLastFilter] = useState({
    id: 0,
    usuarioChatInterno: false,
    ativo: true,
    filterByStatus: true,
    pedagogicAdm: false,
    updaterId: 0,
    usuarioChat: false,
    active: true,
    binds: {},
  });

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const toggleModal = () => {
    setModal(!modal);
  };

  const loadSchoolTerm = () => {
    showLoading();
    const query = schoolTermEmployeeRelationshipListByEmployeeIdQuery(0);
    GraphQL(query, {})
      .then(({ schoolTermEmployeeRelationshipListByEmployeeId }) => {
        if (schoolTermEmployeeRelationshipListByEmployeeId) {
          const resultSchoolTerms =
            schoolTermEmployeeRelationshipListByEmployeeId
              .reduce((acc, item) => acc.concat(item.schoolTerm), [])
              .map((item) => ({
                ...item,
                value: item.id,
                label: item.name,
              }));
          setSchoolTerm(resultSchoolTerms);
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const sanitizeFilter = (filter) => {
    const reassign = { ...filter };
    if (filter.accessProfiles) {
      reassign.binds.accessProfiles = removeLabelAndValueObjectArray(
        filter.accessProfiles
      );
    }
    if (filter.channels) {
      reassign.binds.channels = removeLabelAndValueObjectArray(filter.channels);
    }
    if (filter.terms) {
      reassign.binds.terms = removeLabelAndValueObjectArray(filter.terms);
    }
    if (filter.classes) {
      reassign.binds.classes = removeLabelAndValueObjectArray(filter.classes);
    }
    if (filter.subjects) {
      reassign.binds.subjects = removeLabelAndValueObjectArray(filter.subjects);
    }
    const {
      subjects: subjectList,
      classes,
      channels,
      accessProfiles,
      terms,
      ...rest
    } = reassign;
    return rest;
  };
  const loadEmployees = (filter) => {
    showLoading();
    const query = employeeListByFilter(sanitizeFilter(filter));
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        res.employeeListByFilter = res.employeeListByFilter.map((item) => ({
          ...item,
          activeDescription: t(`general.yesno.${item.active}`),
          formattedCpf: formatCpf(item.cpf),
        }));
        setData(res.employeeListByFilter);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const addItemClickHandler = () => {
    history.push(`/minime/funcionario/mnt/0`);
  };

  const editItemClickHandler = (evt, rowData) => {
    history.push(`/minime/funcionario/mnt/${rowData.id}`);
  };

  const onFilterToggle = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const onFilterClickHandler = (filter) => {
    if (filterIsOpen) {
      onFilterToggle();
    }
    if (filter) {
      setLastFilter(filter);
      loadEmployees(filter);
    } else if (lastFilter) {
      loadEmployees(lastFilter);
    }
  };

  const HandleRemoveItem = (evt, rowData) => {
    const clickedItem = {
      ...rowData,
    };
    setSelectedDto(clickedItem);
    toggleModal();
  };

  const remove = () => {
    toggleModal();
    showLoading();
    const mutation = employeeRemove(selectedDto.id);
    GraphQL(mutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
        onFilterClickHandler();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        hideLoading();
      });
  };

  const loadAccessProfile = () => {
    showLoading();
    const query = relationAccessProfileEmployeeListByEmployeeId(0);
    GraphQL(query, {})
      .then((res) => {
        const accessProfileList =
          res.relationAccessProfileEmployeeListByEmployeeId;
        if (accessProfileList) {
          const access = accessProfileList
            .reduce((acc, item) => acc.concat(item.profile), [])
            .map((item) => ({
              ...item,
              value: item.id,
              label: item.name,
            }));
          setAccessProfile(access);
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const loadCommunicationChannels = () => {
    showLoading();
    const query = relationCommunicationChannelEmployeeListByEmployeeId(0);
    GraphQL(query, {})
      .then((res) => {
        const communicationChannelList =
          res.relationCommunicationChannelEmployeeListByEmployeeId;
        if (communicationChannelList) {
          const channels = communicationChannelList
            .reduce((acc, item) => acc.concat(item.channel), [])
            .map((item) => ({
              ...item,
              value: item.id,
              label: item.name,
            }));
          setCommunicationChannels(channels);
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const loadSubjects = () => {
    showLoading();
    const query = relationSubjectEmployeeListByEmployeeId(0);
    GraphQL(query, {})
      .then((res) => {
        const subjectEmployeeList = res.relationSubjectEmployeeListByEmployeeId;
        if (subjectEmployeeList) {
          const subjectsList = subjectEmployeeList
            .reduce((acc, item) => acc.concat(item.subject), [])
            .map((item) => ({
              ...item,
              value: item.id,
              label: item.name,
            }));
          setSubjects(subjectsList);
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const actionsDisabledByConditional = (propss) => {
    if (propss.actions && propss.actions.length) {
      const copyProps = { ...propss };
      copyProps.actions.find((a) => a.name === ACTION_NAME.EDIT).hidden =
        loggedUser.login &&
        loggedUser.login.toUpperCase() !== SMART_BABY_USER &&
        copyProps.data.user.toUpperCase() === SMART_BABY_USER;
      copyProps.actions.find((a) => a.name === ACTION_NAME.REMOVE).hidden =
        copyProps.data.user.toUpperCase() === SMART_BABY_USER;
    }
  };

  const onPrintReport = () => {
    showLoading();
    const formData = new FormData();
    formData.append(
      REPORT_PARAMETERS.REPORTTYPE,
      REPORT_TYPES.RELA_EMPLOYEE_DETAILING
    );
    generateReport(formData)
      .then(async (res) => {
        openReport(res.data);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('report.error-generate')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const filterBuildFunction = () => (
    <EmployeeFilter
      filterClick={onFilterClickHandler}
      lastFilter={lastFilter}
      accessProfile={accessProfile}
      communicationChannels={communicationChannels}
      subjects={subjects}
      schoolTerm={schoolTerm}
    />
  );

  const customActions = [
    {
      name: ACTION_NAME.REPORT,
      icon: () => <AssignmentIcon />,
      isFreeAction: true,
      tooltip: t('general.detailed-report'),
      onClick: onPrintReport,
    },
  ];

  useEffect(() => {
    loadSchoolTerm();
    loadAccessProfile();
    loadCommunicationChannels();
    loadSubjects();
    onFilterClickHandler();
  }, []);

  return (
    <>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={remove}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    filterBuildFunction={filterBuildFunction}
                    isFiltering={filterIsOpen}
                    filterToggle={onFilterToggle}
                    onRefreshClick={onFilterClickHandler}
                    onAddClick={addItemClickHandler}
                    onEditClick={editItemClickHandler}
                    onRemoveClick={HandleRemoveItem}
                    data={data}
                    columns={columns(t)}
                    pageSize={DEFAULT_PAGE_SIZE}
                    title={t('panels.funcionario')}
                    actionsDisabled
                    actionsDisabledByConditional={actionsDisabledByConditional}
                    customActions={customActions}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

Employee.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(Employee)
);
